import { stateGo } from 'redux-ui-router';
import { anchorStorage } from 'utils';
import { selectMember } from 'logic/member';
import {
  fetchFavouriteVideos,
  selectFavouriteVideos,
  selectFavouriteVideosReload,
  toggleFavouriteVideo,
} from 'logic/favourite';

export const FavouritesVideos = {
  template: `
    <ui-view>
      <div class="favourite-videos py-3 py-md-4">
        <div class="container pt-1 pb-3">
          <div class="row pt-2">
            <div class="col-sm-6 col-lg-4 pb-4"
              ng-repeat="item in $ctrl.pagination.result track by $index">
              <card-video
                heading="item.title"
                duration-in-mins="item.time"
                image="item.thumbnailUrl.large"
                is-favourite="item.isFavourite"
                on-click="$ctrl.onClick(item)"
                on-favourite="$ctrl.toggleFavouriteVideo({
                  memberId: $ctrl.member.id,
                  videoId: item.id,
                  isFavourite: item.isFavourite
                })">
              </card-video>
            </div>
            <div class="col-sm-5 mx-auto mt-3"
              ng-hide="$ctrl.pagination.result.length">
              <favourite-no-result
                is-loading="$ctrl.isLoading">
              </favourite-no-result>
            </div>
          </div>
          <pagination-row
            on-update-param="$ctrl.onUpdatePage(value)"
            pagination="$ctrl.pagination">
          </pagination-row>
        </div>
      </div>
    </ui-view>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (this.shouldFetch) {
          this.fetchFavouriteVideos(this.params);
        }
      },

      $onDestroy() {
        this.disconnect();
      },

      onClick({ id, title }) {
        this.stateGo('favourites.videos.detail', {
          videoId: id,
          page: undefined,
          order: undefined,
        });

        anchorStorage.set($ngRedux.getState(), title);
      },

      onUpdatePage(page) {
        this.stateGo('favourites.videos', { page });
      },

      mapState({ favourite, member, router }) {
        const stateMember = selectMember(member);

        const params = {
          ...router.currentParams,
          memberId: stateMember.id,
        };

        const pagination = selectFavouriteVideos(favourite, params);
        const { result } = pagination;
        const { isLoading } = favourite;

        return {
          isLoading,
          pagination,
          params,
          member: stateMember,
          shouldFetch: selectFavouriteVideosReload(favourite, result),
        };
      },

      mapDispatch() {
        return {
          fetchFavouriteVideos,
          stateGo,
          toggleFavouriteVideo,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Favourites/Videos.js